import React, { Component } from 'react';
import PropTypes from 'prop-types';
import langIsEn from '../../utils/langIsEn';
import styles from './ContentTitle.css';

class ContentTitle extends Component {
  static propTypes = {
    engName: PropTypes.string,
    chtName: PropTypes.string,
  };

  static defaultProps = {
    engName: null,
    chtName: null,
  };

  render() {
    const { engName, chtName } = this.props;

    return (
      <section className='container'>
        <h1 className={styles.title}>
          <div>
            <span>
              <span className={styles.engName}>{engName}</span>
            </span>
            {!langIsEn() &&
              chtName &&
              <span className={styles.chtName}>&nbsp;{chtName}</span>
            }
          </div>
        </h1>
      </section>
    );
  }
}

export default ContentTitle;



// WEBPACK FOOTER //
// ./src/components/content-title/ContentTitle.js